import fileDownload from "js-file-download";
import React, { useContext, useEffect, useState } from "react";
import { getMoisString } from "../../services/Constante";
import { findOne, getfile } from "../../services/Document__Servive";
import notifyContext from "../Context/notifyContext";
import PdfRender from "../PdfRender/PdfRender";
import Loader from "../Loader/Loader";

const ModalDocument = ({ documentId = 0, initialValue = null }) => {
  const notify = useContext(notifyContext);
  const [selectedFile, setSelectedFile] = useState(null);
  const [doc, setDoc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (initialValue) {
      setDoc({ ...initialValue });
      fecthFile(initialValue.chemin);
    } else if (documentId > 0) {
      fetchOne(documentId);
    } else {
      setDoc(null);
    }
  }, [initialValue, documentId]);

  const fetchOne = async (documentId) => {
    findOne(documentId)
      .then((response) => {
        setDoc(response.data);
        if (response.data.filename) {
          fecthFile(response.data.chemin);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const fecthFile = async (filename) => {
    getfile(filename)
      .then((response) => {
        setSelectedFile(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {doc && (
        <div className="doc-view-modal">
          <div className="preview">
            {selectedFile ? (
              <>
                <button
                  className="btn download"
                  onClick={() => fileDownload(selectedFile, doc.nameDownload)}
                >
                  Télécharger
                </button>
                <PdfRender file={selectedFile} />
              </>
            ) : (
              <p>Aucun aperçu disponible</p>
            )}
          </div>
          <div className="infos">
            <div className="infos__item">
              <p className="label">Client : </p>
              <p className="value">{doc.salarie.client.nom}</p>
            </div>
            <div className="infos__item">
              <p className="label">Salarié : </p>
              <p className="value">{doc.salarie.fullname}</p>
            </div>
            <div className="infos__item">
              <p className="label">Mois : </p>
              <p className="value">{getMoisString(doc.mois)}</p>
            </div>
            <div className="infos__item">
              <p className="label">Année : </p>
              <p className="value">{doc.annee}</p>
            </div>
            <div className="infos__item">
              <p className="label">Créé le : </p>
              <p className="value">{` ${new Date(
                doc.create_at
              ).toLocaleDateString("fr-Fr")}  à ${new Date(
                doc.create_at
              ).toLocaleTimeString("fr-Fr")} `}</p>
            </div>
            <div className="infos__item">
              <p className="label">Dernière modification : </p>
              <p className="value">
                {` ${new Date(doc.last_modified).toLocaleDateString(
                  "fr-Fr"
                )}  à ${new Date(doc.last_modified).toLocaleTimeString(
                  "fr-Fr"
                )} `}
              </p>
            </div>
          </div>
        </div>
      )}

      {isLoading && <Loader loadingMsg="Chargement..." />}
    </>
  );
};

export default ModalDocument;
